/* eslint-disable no-param-reassign -- Redux Toolkit uses Immer */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface EntityInitialData {
  requestor?: {
    id?: string;
    userName?: string;
    firstName?: string;
  };
  requestee?: {
    id?: string;
    userName?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    manager?: string;
    displayName?: string;
  };
  loggedInUser?: {
    id?: string;
    userName?: string;
    firstName?: string;
  };
}

export interface InitialDataState {
  initialData: EntityInitialData | null;
  /** Raw `formElementsData` from the entity load API (`/submit/data/load` for live forms, `/preview/data/load` for preview) — used for `valuesToSearch` passthrough until the user edits the field. */
  loadedFormElementsData: Record<string, unknown> | null;
}

const initialState: InitialDataState = {
  initialData: null,
  loadedFormElementsData: null,
};

const initialDataSlice = createSlice({
  name: 'initialData',
  initialState,
  reducers: {
    setInitialData: (
      state,
      action: PayloadAction<EntityInitialData | null>
    ) => {
      state.initialData = action.payload;
    },
    setLoadedFormElementsData: (
      state,
      action: PayloadAction<Record<string, unknown> | null>
    ) => {
      state.loadedFormElementsData = action.payload;
    },
    clearInitialData: (state) => {
      state.initialData = null;
      state.loadedFormElementsData = null;
    },
  },
});

export const initialDataActions = initialDataSlice.actions;
export const initialDataReducer = initialDataSlice.reducer;
export default initialDataSlice.reducer;
